import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { teal, white } from '../colors';
/* eslint-disable react/jsx-curly-brace-presence */

export var Hamburger =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Hamburger, _PureComponent);

  function Hamburger() {
    _classCallCheck(this, Hamburger);

    return _possibleConstructorReturn(this, _getPrototypeOf(Hamburger).apply(this, arguments));
  }

  _createClass(Hamburger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          color = _this$props.color;
      return React.createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 32 32"
      }, React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, React.createElement("rect", {
        width: "32",
        height: "32"
      }), React.createElement("path", {
        fill: color,
        d: "M7.2,23.4 C7.2,22.8477153 7.65274518,22.4 8.19667988,22.4 L23.8033201,22.4 C24.3537712,22.4 24.8,22.8438648 24.8,\n            23.4 C24.8,23.9522847 24.3472548,24.4 23.8033201,24.4 L8.19667988,24.4 C7.64622878,24.4 7.2,23.9561352 7.2,23.4 Z M7.2,\n            16.2 C7.2,15.6477153 7.65274518,15.2 8.19667988,15.2 L23.8033201,15.2 C24.3537712,15.2 24.8,15.6438648 24.8,16.2 C24.8,\n            16.7522847 24.3472548,17.2 23.8033201,17.2 L8.19667988,17.2 C7.64622878,17.2 7.2,16.7561352 7.2,16.2 Z M7.2,9 C7.2,\n            8.44771525 7.65274518,8 8.19667988,8 L23.8033201,8 C24.3537712,8 24.8,8.44386482 24.8,9 C24.8,9.55228475 24.3472548,\n            10 23.8033201,10 L8.19667988,10 C7.64622878,10 7.2,9.55613518 7.2,9 Z"
      })));
    }
  }]);

  return Hamburger;
}(PureComponent);
Hamburger.propTypes = {
  width: PropTypes.string,
  color: PropTypes.string
};
Hamburger.defaultProps = {
  width: '32px',
  color: teal.base
};
export var Close =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(Close, _PureComponent2);

  function Close() {
    _classCallCheck(this, Close);

    return _possibleConstructorReturn(this, _getPrototypeOf(Close).apply(this, arguments));
  }

  _createClass(Close, [{
    key: "render",
    // eslint-disable-line react/no-multi-comp
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          color = _this$props2.color,
          cropped = _this$props2.cropped;
      return cropped ? React.createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 16 16"
      }, React.createElement("path", {
        fillRule: "evenodd",
        fill: color,
        d: "M7.29289322,8 L2.14644661,2.85355339 C1.95118446,2.65829124 1.95118446,2.34170876 2.14644661,2.14644661 C2.34170876,\n          1.95118446 2.65829124,1.95118446 2.85355339,2.14644661 L8,7.29289322 L13.1464466,2.14644661 C13.3417088,1.95118446 13.6582912,\n          1.95118446 13.8535534,2.14644661 C14.0488155,2.34170876 14.0488155,2.65829124 13.8535534,2.85355339 L8.70710678,8 L13.8535534,\n          13.1464466 C14.0488155,13.3417088 14.0488155,13.6582912 13.8535534,13.8535534 C13.6582912,14.0488155 13.3417088,14.0488155 13.1464466,\n          13.8535534 L8,8.70710678 L2.85355339,13.8535534 C2.65829124,14.0488155 2.34170876,14.0488155 2.14644661,13.8535534 C1.95118446,\n          13.6582912 1.95118446,13.3417088 2.14644661,13.1464466 L7.29289322,8 Z"
      })) : React.createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 32 32"
      }, React.createElement("path", {
        fillRule: "evenodd",
        fill: color,
        d: "M15.012471,16.4266845 L8.29712776,23.1420278 C7.89821149,23.540944 7.90443226,24.1678882 8.29495655,24.5584125 C8.68820351,\n          24.9516595 9.31961791,24.9479647 9.71134132,24.5562413 L16.4266845,17.8408981 L23.1420278,24.5562413 C23.540944,24.9551576 24.1678882,\n          24.9489368 24.5584125,24.5584125 C24.9516595,24.1651656 24.9479647,23.5337512 24.5562413,23.1420278 L17.8408981,16.4266845 L24.5562413,\n          9.71134132 C24.9551576,9.31242506 24.9489368,8.68548085 24.5584125,8.29495655 C24.1651656,7.9017096 23.5337512,7.90540434 23.1420278,\n          8.29712776 L16.4266845,15.012471 L9.71134132,8.29712776 C9.31242506,7.89821149 8.68548085,7.90443226 8.29495655,8.29495655 C7.9017096,\n          8.68820351 7.90540434,9.31961791 8.29712776,9.71134132 L15.012471,16.4266845 Z"
      }));
    }
  }]);

  return Close;
}(PureComponent);
Close.propTypes = {
  width: PropTypes.string,
  color: PropTypes.string,
  cropped: PropTypes.bool
};
Close.defaultProps = {
  width: '32px',
  color: white,
  cropped: false
};